export type ErrorWithCause = Error & {
  cause?: Error;
};

function isErrorWithCause(error: ErrorWithCause): error is ErrorWithCause {
  return 'cause' in error;
}

const isError = (error: unknown): error is Error => error instanceof Error;

const debugMsg = (...msg: unknown[]) =>
  window.console.info('[SentryDev]', ...msg);
const debugError = (...msg: unknown[]) =>
  window.console.error('[FreedomAppDev]', ...msg);
const getReadableError = <T extends Error>(mainError: string | T, error: T) => {
  const err: ErrorWithCause = isError(mainError)
    ? mainError
    : new Error(mainError);
  err.cause = error;
  return err;
};

const createCustomErrorText = (prefix: string, error: string) =>
  `${prefix}_${error}`;

export const sentryLib = {
  debugMsg,
  debugError,
  getReadableError,
  isErrorWithCause,
  createCustomErrorText,
};
